import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { DragDropContext } from "react-beautiful-dnd";
import JobListColumn from "../components/JobListColumn";
import { reorderColumnMap } from "../reorder";
import { FaPlus } from 'react-icons/fa';

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL


const Tracker = ({ currentUser, columnMap, setColumnMap, isOpen, setIsOpen }) => {
    

    const getJobs = async () => {
        console.log('getting jobs')
        const res = await fetch(`${REACT_APP_BACKEND_URL}/jobs/`, {
            method: "GET",
            headers: {
                "Authorization": `Token ${currentUser.token}`
            }
        });
        const data = await res.json();
        if (data !== columnMap) {
            setColumnMap(data)
        }
    };
    const updateJobs = async (reorderedMap, columnsChanged) => {
        console.log('updatingJobs')
        const myReorderedMap = {}
        for (let column of columnsChanged) {
            myReorderedMap[column] = reorderedMap[column]
        }
        const res = await fetch(`${REACT_APP_BACKEND_URL}/jobs/update/`, {
            method: "POST",
            headers: {
                "Content-Type": 'application/json',
                "Authorization": `Token ${currentUser.token}`
            },
            body: JSON.stringify(myReorderedMap)
        });
        const data = await res.json();
        console.log(data)
    };

    useEffect(() => {
        getJobs()
    }, []);
    return currentUser?
    (
        <>
            <div className='w-full flex justify-center my-2'>
                <div className='px-12 py-3 cursor-pointer add-job-btn' onClick={() => setIsOpen(!isOpen)}><FaPlus /></div>
            </div>
            <div className='relative'>
                
                <DragDropContext
                    onDragEnd={({ destination, source }) => {
                        if (!destination) { return; }
                        console.log('drag end')
                        const { reorderedMap, columnsChanged } = reorderColumnMap(columnMap, source, destination)
                        if (reorderedMap !== columnMap) {
                            setColumnMap(reorderedMap)
                            updateJobs(reorderedMap, columnsChanged)
                        }

                    }}>
                    <div className="top-0 bottom-0 drag-container no-select overflow-x-scroll overflow-y-hidden h-full">
                        {Object.entries(columnMap).map(([column, jobList]) => (
                            <JobListColumn
                                internalScroll
                                key={column}
                                listId={column}
                                listType="CARD"
                                jobList={jobList}
                                className='drag-column'
                            >
                            </JobListColumn>
                        ))}
                    </div>
                </DragDropContext>
                
            </div>
        </>
    )
    : (<Navigate to='/connect'/>)
};
export default Tracker